
import { Payment } from '../types';

export const mockPayments: Payment[] = [
  {
    id: 'payment-1',
    rentalId: 'rental-1',
    rentalHumanNumber: 'R-2024-001',
    courierId: 'courier-1',
    courierName: 'Иван Петров',
    amount: 500,
    date: '2024-01-15T10:30:00Z',
    status: 'paid',
    method: 'card',
    human_number: 'P-2024-001',
    type: 'rental',
    description: 'Аренда велосипеда на неделю'
  },
  {
    id: 'payment-2',
    rentalId: 'rental-2',
    rentalHumanNumber: 'R-2024-002',
    courierId: 'courier-2',
    courierName: 'Анна Сидорова',
    amount: 1500,
    date: '2024-02-01T14:20:00Z',
    status: 'completed',
    method: 'sbp',
    human_number: 'P-2024-002',
    type: 'subscription',
    description: 'Подписка на месяц'
  },
  {
    id: 'payment-3',
    rentalId: 'rental-3',
    rentalHumanNumber: 'R-2024-003',
    courierId: 'courier-3',
    courierName: 'Алексей Иванов',
    amount: 300,
    date: '2024-02-10T09:15:00Z',
    status: 'pending',
    method: 'card',
    human_number: 'P-2024-003',
    type: 'rental',
    description: 'Доплата за превышение пробега'
  }
];
